import {
  ENV,
  ENV_ENUM,
  HOST_URL,
  LINK_REDIRECT_AWS,
  LINK_LOGOUT_AWS,
  LINK_REDIRECT_AWS_LOCAL,
} from '@/shared/config/env';
import isEnvLocalDev from '@/shared/lib/browser/isEnvLocalDev';
import { awsExportAlpha, awsExportCustomer, awsExportDelta, awsExportStaging } from './awsExports';

/**
 * Chooses which URL Cognito returns the user to after single sign-on. Substitutes the local development redirect when running against a local dev environment, otherwise keeps the supplied URL.
 *
 * @param url - Deployed redirect URL used outside local development.
 * @returns The redirect URL to register with Cognito.
 */
const generateLinkRedirectAws = (url: string) => {
  if (isEnvLocalDev()) {
    return LINK_REDIRECT_AWS_LOCAL;
  }
  return url;
};

/**
 * Picks the Amplify configuration for the single sign-on pool of the current deployment. Returns the alpha, delta or staging export when ENV matches, and falls back to the customer export otherwise.
 *
 * @returns The AWS Amplify export object for the active environment.
 */
const generateAwsConfig = () =>
  ENV === ENV_ENUM.alpha
    ? awsExportAlpha
    : ENV === ENV_ENUM.delta
      ? awsExportDelta
      : ENV === ENV_ENUM.staging
        ? awsExportStaging
        : awsExportCustomer;

const LINK_CONFIG = {
  LINK_REDIRECT_AWS: generateLinkRedirectAws(LINK_REDIRECT_AWS),
  LINK_LOGOUT_AWS,
  AWS_CONFIG: generateAwsConfig(),
  HOST_URL,
};

export default LINK_CONFIG;
